var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 18.7 19.7",
    style: {
      enableBackground: "new 0 0 18.7 19.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5,10.6c1.2-1.1,1.9-2.7,1.9-4.5c0-3.4-2.7-6.1-6.1-6.1C6,0,3.2,2.7,3.2,6.1c0,1,0.3,2.1,0.8,3c0.1,0.1,0.2,0.3,0.3,0.4 c0.3,0.4,0.5,0.7,0.9,1C2.3,12,0.3,14.9,0,18.2c0,0.4,0.1,0.7,0.4,1c0.3,0.3,0.6,0.4,1,0.4h16c0.4,0,0.7-0.2,1-0.4s0.4-0.6,0.4-1 C18.4,14.9,16.4,12,13.5,10.6z M7.8,9.2c-0.1,0-0.2-0.1-0.3-0.2c-0.4-0.3-0.8-0.6-1-1C6.4,8,6.4,7.9,6.3,7.8C6,7.3,5.9,6.7,5.9,6.1 c0-1.9,1.6-3.5,3.5-3.5c1.9,0,3.5,1.6,3.5,3.5c0,1.9-1.5,3.5-3.5,3.5c0,0,0,0,0,0s0,0,0,0C8.8,9.6,8.3,9.5,7.8,9.2z M2.9,17 c0.8-2.8,3.4-4.8,6.4-4.8c0,0,0,0,0,0c0,0,0,0,0,0c3,0,5.6,2,6.4,4.8H2.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.1b5c90b46114358b562231a167bc97ab.svg";
export { ForwardRef as ReactComponent };